module.exports = __webpack_public_path__ + "static/1_right-3f8369b3ad6541132cc4b99e9fa2ceb9.png";